/* ===== MEMOMAP: Picture Popup Toggle + Modal (mit Icons aus Shopify) ===== */
(function () {
  const KEY_ENABLED = "picture_popup_enabled";
  const KEY_VARIANT = "picture_popup_variant";

  /* 🔗 Deine Shopify-Bilder */
//const ICON_MAIL = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Email_Symbol.png?v=1761299539";
//const ICON_INFO = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Ausrufezeichen.png?v=1761299721";
const ICON_CHECK = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Haken_Symbol.png?v=1761299539";
const ICON_QUESTION = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Fragezeichen.png?v=1761299538";

/* ✅ Echte Varianten-Bilder */
const IMG_CLASSIC = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Classic.png?v=1761300736";
const IMG_FRAME   = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Frame.png?v=1761300736";
const IMG_JOY     = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Joy.png?v=1761300741";
const IMG_VINTAGE = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Vintage.png?v=1761300737";

const MAILTO = "mailto:hey@memomap.store";
const MAILTO_QUESTION = "mailto:hey@memomap.store?subject=Frage%20zum%20Foto-Upload";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    injectStyles();
    ensureModal();
    setupOrRestore();
    observeDOMChanges();
  }

  function setupOrRestore() {
    const toggle = document.querySelector("#photoToggle");
    if (!toggle) return;

    const modal  = document.getElementById("picturePopupModal");
    const form   = document.getElementById("picturePopupForm");
    const saveBtn= document.getElementById("picturePopupSave");

    const storedEnabled = localStorage.getItem(KEY_ENABLED) === "true";
    const storedVariant = localStorage.getItem(KEY_VARIANT) || "";
    toggle.checked = storedEnabled;

    // Öffnen & Schließen
    function openModal() {
      const sv = localStorage.getItem(KEY_VARIANT) || "";
      form.querySelectorAll('input[name="picturePopupVariant"]').forEach(r => (r.checked = false));
      if (sv) {
        const r = form.querySelector(`input[value="${sv}"]`);
        if (r) r.checked = true;
      }
      modal.setAttribute("aria-hidden", "false");
      updateSaveDisabled();
    }
    function closeModal() {
      modal.setAttribute("aria-hidden", "true");
    }

    // Aktiviert/Deaktiviert den Button dynamisch
    function updateSaveDisabled() {
      const any = form.querySelector('input[name="picturePopupVariant"]:checked');
      if (any) saveBtn.classList.remove("is-disabled");
      else saveBtn.classList.add("is-disabled");
    }


    // Live beim Anklicken der Radio-Buttons
    form.addEventListener("change", (e) => {
      if (e.target.name === "picturePopupVariant") {
        updateSaveDisabled();
      }
    });

    // Verhalten des Toggles
    toggle.onchange = () => {
      const enabled = localStorage.getItem(KEY_ENABLED) === "true";
      const sv = localStorage.getItem(KEY_VARIANT) || "";

      if (toggle.checked) {
        if (enabled && sv) window.picturePopupPrefs = { enabled: true, variant: sv };
        else openModal();
      } else {
        if (enabled && sv) {
          const confirmDiscard = window.confirm("Bildauswahl verwerfen?");
          if (confirmDiscard) {
            localStorage.setItem(KEY_ENABLED, "false");
            localStorage.removeItem(KEY_VARIANT);
            form.querySelectorAll('input[name="picturePopupVariant"]').forEach(r => (r.checked = false));
          } else {
            toggle.checked = true;
            return;
          }
        } else {
          localStorage.setItem(KEY_ENABLED, "false");
          localStorage.removeItem(KEY_VARIANT);
          form.querySelectorAll('input[name="picturePopupVariant"]').forEach(r => (r.checked = false));
        }
      }
    };

    // Schließen (X oder Overlay)
    modal.addEventListener("click", (e) => {
      if (e.target.matches("[data-mm-close]")) {
        const variant = localStorage.getItem(KEY_VARIANT);
        if (!variant) toggle.checked = false;
        closeModal();
      }
    });

    // ESC-Taste
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
        const variant = localStorage.getItem(KEY_VARIANT);
        if (!variant) toggle.checked = false;
        closeModal();
      }
    });

    // 💾 SPEICHERN
    saveBtn.onclick = () => {
      const fd = new FormData(form);
      const variant = fd.get("picturePopupVariant");

      if (!variant) {
        // Kein Layout → Hinweis
        saveBtn.classList.add("mm-shake");
        alert("Bitte wähle ein Layout, bevor du bestätigst.");
        setTimeout(() => saveBtn.classList.remove("mm-shake"), 600);
        return;
      }

      // ✅ Alles korrekt → speichern
      localStorage.setItem(KEY_ENABLED, "true");
      localStorage.setItem(KEY_VARIANT, String(variant));
      toggle.checked = true;
      closeModal();
    };
  }


function injectStyles() {
  if (document.getElementById("picturePopupCSS")) return;
  const css = `
/* Modal Grundlayout */
.mm-modal{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center}
.mm-modal[aria-hidden="true"]{display:none}
.mm-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.45)}
.mm-modal__dialog{
  position:relative;background:#fff;border-radius:14px;box-shadow:0 10px 30px rgba(0,0,0,.18);
  width:min(980px,94vw);max-height:88vh;display:flex;flex-direction:column;overflow:hidden
}

/* Header: Titel mittig */
.mm-modal__header{
  position:relative;display:flex;align-items:center;justify-content:center;
  padding:16px 18px;border-bottom:1px solid #eef1f4;text-align:center
}
.mm-modal__title{
  margin:0 auto;font-size:28px;line-height:1.2;font-weight:650;color:#5a6c7a;width:100%
}
.mm-modal__mail{display:inline-flex;align-items:center}
.mm-modal__mail img{width:22px;height:22px}
.mm-modal__close{
  position:absolute;right:16px;top:10px;background:none;border:none;font-size:26px;cursor:pointer;color:#9aa7b3
}

/* Body */
.mm-modal__body{padding:18px 18px 8px;overflow:auto}

/* Intro – bessere Zeilenumbrüche */
.mm-intro{
  max-width:760px;margin:0 auto 10px;text-align:center;color:#637283;font-size:16px;line-height:1.5;
  text-wrap:balance;           /* moderne Browser: ausgewogene Umbrüche */
  -webkit-hyphens:auto;hyphens:auto;
}
.mm-intro b{color:#000}
.mm-intro a{color:#2a6db0;text-underline-offset:3px;font-weight:800;white-space:nowrap} /* E-Mail nicht umbrechen */
.mm-intro .keep{white-space:nowrap} /* Gruppen wie "E-Mail mit" zusammenhalten */

/* Optionale, responsive Break-Klassen */
.mm-intro .br-md,.mm-intro .br-sm{display:none}
@media (max-width:1024px){ .mm-intro .br-md{display:block} }
@media (max-width:560px){ .mm-intro .br-sm{display:block} }

/* Varianten-Grid */
.mm-variants{
  display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:18px;justify-items:center;margin:20px 0 6px
}
.mm-card{
  text-align:center;max-width:200px;display:flex;flex-direction:column;align-items:center
}

/* Bild-Container & Bild – Anti-Stretch */
.mm-card__img{width:100%;height:auto !important;aspect-ratio:auto !important}
.mm-card__img img{
  display:block;width:100%;max-width:100%;height:auto !important;aspect-ratio:auto;object-fit:contain;
  box-shadow:0 6px 18px rgba(0,0,0,.20);transition:transform .2s ease,box-shadow .2s ease
}
.mm-card__img img:hover{transform:scale(1.03);box-shadow:0 10px 26px rgba(0,0,0,.22)}

/* Label */
.mm-card__label{margin-top:8px;font-size:18px;font-weight:600}

/* Radio-Button (runder Punkt unter Bild) */
.mm-radio{margin-top:8px;display:flex;justify-content:center}
.mm-radio input{
  -webkit-appearance:none;appearance:none;position:relative;width:18px;height:18px;border:2px solid #7d97a7;border-radius:50%;
  background:#fff;cursor:pointer;transition:border-color .2s ease
}
.mm-radio input:hover{border-color:#637283}
.mm-radio input:checked{border-color:#637283}
.mm-radio input::after{
  content:"";position:absolute;top:50%;left:50%;width:8px;height:8px;background:#637283;border-radius:50%;
  transform:translate(-50%,-50%) scale(0);transition:transform .15s ease-out
}
.mm-radio input:checked::after{transform:translate(-50%,-50%) scale(1)}

/* Info-Block */
.mm-info{
  max-width:860px;margin:14px auto 6px;color:#637283;font-size:15px;line-height:1.5;
  display:flex;align-items:flex-start;justify-content:center;gap:12px;text-align:center
}
.mm-info img{width:20px;height:20px;align-self:center;margin-top:14px}
.mm-info b{color:#000}

/* Footer */
.mm-modal__footer{
  display:flex;gap:12px;justify-content:center;padding:16px;border-top:1px solid #eef1f4;background:#fafcfd
}
.mm-btn{
  border:1px solid #d1dbe3;background:#fff;border-radius:12px;padding:11px 16px;font-size:16px;font-weight:700;cursor:pointer;
  display:flex;align-items:center;gap:8px
}
.mm-btn--primary{background:#97aebb;border-color:#97aebb;color:#fff}
.mm-btn--primary:disabled{opacity:.6;cursor:not-allowed}
.mm-btn--ghost{background:#eef3f7;color:#3f5666;border-color:#eef3f7}
.mm-btn img{width:18px;height:18px}

/* Disabled trotzdem klickbar (für Warnhinweis) */
.mm-btn.is-disabled{opacity:.6;cursor:pointer;pointer-events:all}
.mm-btn.is-disabled:hover{opacity:.8}

/* Responsive Tweaks */
@media (max-height:860px){
  .mm-card__img img{max-height:190px;width:auto}
  .mm-modal__title{font-size:26px}
}
@media (max-width:1024px){
  .mm-variants{grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
  .mm-card{max-width:160px}
  .mm-modal__dialog{max-height:86vh}
}
@media (max-width:560px){
  .mm-variants{grid-template-columns:1fr;gap:12px}
  .mm-card{max-width:320px}
}

/* Shake für Hinweis */
@keyframes mm-shake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-6px)}40%,80%{transform:translateX(6px)}}
.mm-shake{animation:mm-shake .4s ease}

/* Titel immer optisch mittig, mit Platz für das X */
.mm-modal__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 18px;
  border-bottom: 1px solid #eef1f4;
  text-align: center;
}

/* Kein Umbruch + Platz für Close + responsive Font */
.mm-modal__title {
  margin: 0;
  font-weight: 650;
  color: #5a6c7a;
  line-height: 1.2;
  /* verhindert, dass das X den Text überlappt */
  max-width: calc(100% - 56px);   /* 56px ≈ Breite des Close-Bereichs */
  white-space: nowrap;            /* KEIN Umbruch */
  overflow: hidden;
  text-overflow: ellipsis;        /* falls es extrem schmal wird */
  font-size: clamp(18px, 4.6vw, 28px); /* skaliert auf kleinen Geräten runter */
}

.mm-modal__close {
  position: absolute;
  right: 16px;
  top: 10px;
  background: none;
  border: none;
  font-size: 26px;
  cursor: pointer;
  color: #9aa7b3;
}

/* Optional: noch etwas kleiner auf sehr schmalen Phones */
@media (max-width: 360px) {
  .mm-modal__title { font-size: clamp(16px, 5.2vw, 22px); }
}

`;
  const style = document.createElement("style");
  style.id = "picturePopupCSS";
  style.textContent = css;
  document.head.appendChild(style);
}



  function ensureModal() {
    if (document.getElementById("picturePopupModal")) return;
    const modal = document.createElement("div");
    modal.id = "picturePopupModal";
    modal.className = "mm-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="mm-modal__backdrop" data-mm-close></div>
      <div class="mm-modal__dialog" role="dialog">
        <div class="mm-modal__header">
          <h3 class="mm-modal__title">Anleitung zum Foto-Upload</h3>
          <button class="mm-modal__close" type="button" data-mm-close aria-label="Schließen">×</button>
        </div>

        <div class="mm-modal__body">
          <p class="mm-intro">
            Wähle eines der folgenden Layouts und schicke uns nach dem Bestellabschluss eine E-Mail mit <br>
            deinem <b>Foto</b> und deiner <b>Bestellnummer</b><br>
            an <a href="${MAILTO}">Hey@memomap.store</a>
          </p>

          <form id="picturePopupForm" class="mm-form" novalidate>
            <div class="mm-variants">
              ${[
                {v:1,label:"Classic",img:IMG_CLASSIC},
                {v:2,label:"Frame",img:IMG_FRAME},
                {v:3,label:"Joy",img:IMG_JOY},
                {v:4,label:"Vintage",img:IMG_VINTAGE},
              ].map(o=>`
                <label class="mm-card">
                  <span class="mm-card__img"><img src="${o.img}" alt="${o.label}"></span>
                  <span class="mm-card__label">${o.label}</span>
                  <span class="mm-radio"><input type="radio" name="picturePopupVariant" value="${o.v}" aria-label="${o.label}"></span>
                </label>`).join("")}
            </div>
          </form>

          <div class="mm-info">
            <div>
              Anschließend erhälst du eine <b>Vorschau</b> deiner Memomap zur Freigabe.
              <br><br>
              <i>Hinweis:</i> Bitte beachte, dass sich der Kartenausschnitt durch das Bild auf die obere Hälfte
              verkleinert und fokussiere dich aus Platzgründen auf die wichtigsten Reisestationen.
            </div>

          </div>
        </div>

        <div class="mm-modal__footer">
          <button class="mm-btn mm-btn--primary is-disabled" type="button" id="picturePopupSave">
            <img src="${ICON_CHECK}" alt="">Bestätigen
          </button>
          <a class="mm-btn mm-btn--ghost" href="${MAILTO_QUESTION}">
            <img src="${ICON_QUESTION}" alt="">Frage stellen
          </a>
        </div>
      </div>`;
    document.body.appendChild(modal);
  }

  function observeDOMChanges() {
    const observer = new MutationObserver(() => {
      const newToggle = document.querySelector("#photoToggle");
      if (newToggle && !newToggle.dataset.mmBound) {
        newToggle.dataset.mmBound = "true";
        setupOrRestore();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
